import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const moveCarouselBanner = async ({
	id,
	offset
}: MoveCarouselBannerOptions) => {
	const url = `/homepage/admin/promotion/${id}/move/`;
	const response = await cmsClient.put<unknown>(url, { offset });

	return response.data;
};

const useMovePromotionBanner = () => {
	const mutation = useMutation(moveCarouselBanner);

	return mutation;
};

export default useMovePromotionBanner;
